package one.devsbox.www.ui.widgets

import androidx.compose.animation.*
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.text.input.TextFieldLineLimits
import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.foundation.text.input.delete
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Filter
import compose.assets.svg.Search
import compose.assets.svg.TrashOutline
import one.devsbox.www.provider.LocalDisplayProvider


@Composable
@OptIn(ExperimentalMaterial3ExpressiveApi::class, ExperimentalLayoutApi::class)
fun SearchBox(
    state: TextFieldState,
    hint: String,
    modifier: Modifier = Modifier,
    actions: List<@Composable RowScope.() -> Unit> = emptyList()
) {

    var actionsExpanded by remember { mutableStateOf(false) }
    var isFocused by remember { mutableStateOf(false) }

    val dp = LocalDisplayProvider.current.state

    if (dp.smallScreen) {
        Column(
            modifier = modifier .border(
                width = if (isFocused) 1.dp else 0.5.dp,
                color = if (isFocused) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.primary.copy(alpha = 0.4f),
                shape = MaterialTheme.shapes.extraLarge
            ),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(
                        color = if (isFocused) MaterialTheme.colorScheme.primaryContainer.copy(alpha = 0.05F) else Color.Transparent,
                        shape = MaterialTheme.shapes.extraLarge
                    )
                   ,
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                TextField(
                    state = state,
                    shape = MaterialTheme.shapes.extraLarge,
                    placeholder = {
                        Text(hint)
                    },
                    lineLimits = TextFieldLineLimits.SingleLine,
                    modifier = Modifier
                        .weight(1F)
                        .onFocusChanged { isFocused = it.isFocused },
                    leadingIcon = {
                        Icon(
                            imageVector = Svg.Search,
                            contentDescription = null,
                            modifier = Modifier.padding(horizontal = 16.dp).size(24.dp)
                        )
                    },
                    trailingIcon = {
                        androidx.compose.animation.AnimatedVisibility(
                            visible = state.text.isNotEmpty(),
                            enter = fadeIn() + scaleIn(),
                            exit = fadeOut() + scaleOut()
                        ) {
                            IconButton(
                                onClick = {
                                    state.edit {
                                        delete(0, length)
                                    }
                                }) {
                                Icon(
                                    imageVector = Svg.TrashOutline,
                                    contentDescription = null,
                                    modifier = Modifier.size(24.dp)
                                )
                            }
                        }
                    },
                    colors = TextFieldDefaults.colors(
                        focusedIndicatorColor = Color.Transparent,
                        disabledIndicatorColor = Color.Transparent,
                        errorIndicatorColor = Color.Transparent,
                        unfocusedIndicatorColor = Color.Transparent,
                        focusedContainerColor = Color.Transparent,
                        disabledContainerColor = Color.Transparent,
                        unfocusedContainerColor = Color.Transparent
                    ),
                )

                if (actions.isNotEmpty()) {
                    IconButton(
                        onClick = { actionsExpanded = !actionsExpanded },
                        modifier = Modifier.padding(end = 8.dp)
                    ) {
                        Icon(
                            imageVector = Svg.Filter,
                            contentDescription = "Toggle Filters",
                            tint = if (actionsExpanded) MaterialTheme.colorScheme.secondary else MaterialTheme.colorScheme.onBackground,
                            modifier = Modifier.size(24.dp)
                        )
                    }
                }
            }

            if (actions.isNotEmpty()) {
                androidx.compose.animation.AnimatedVisibility(
                    visible = actionsExpanded,
                    enter = fadeIn() + expandVertically(),
                    exit = fadeOut() + shrinkVertically()
                ) {
                    FlowRow(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 8.dp),
                        horizontalArrangement = Arrangement.spacedBy(12.dp, Alignment.End)
                    ) {
                        actions.forEach { action ->
                            Row {
                                action()
                            }
                        }
                    }
                }
            }
        }
    } else {
        Row(
            modifier = modifier
                .background(
                    color = if (isFocused) MaterialTheme.colorScheme.primaryContainer.copy(alpha = 0.05F) else Color.Transparent,
                    shape = MaterialTheme.shapes.extraLarge
                )
                .border(
                    width = if (isFocused) 1.dp else 0.5.dp,
                    color = if (isFocused) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.primary.copy(alpha = 0.4f),
                    shape = MaterialTheme.shapes.extraLarge
                ),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            TextField(
                state = state,
                shape = MaterialTheme.shapes.extraLarge,
                placeholder = {
                    Text(hint)
                },
                lineLimits = TextFieldLineLimits.SingleLine,
                modifier = Modifier
                    .weight(1F)
                    .onFocusChanged { isFocused = it.isFocused },
                leadingIcon = {
                    Icon(
                        imageVector = Svg.Search,
                        contentDescription = null,
                        modifier = Modifier.padding(horizontal = 16.dp).size(24.dp)
                    )
                },
                trailingIcon = {
                    androidx.compose.animation.AnimatedVisibility(
                        visible = state.text.isNotEmpty(),
                        enter = fadeIn() + scaleIn(),
                        exit = fadeOut() + scaleOut()
                    ) {
                        IconButton(
                            onClick = {
                                state.edit {
                                    delete(0, length)
                                }
                            }) {
                            Icon(
                                imageVector = Svg.TrashOutline,
                                contentDescription = null,
                                modifier = Modifier.size(24.dp)
                            )
                        }
                    }
                },
                colors = TextFieldDefaults.colors(
                    focusedIndicatorColor = Color.Transparent,
                    disabledIndicatorColor = Color.Transparent,
                    errorIndicatorColor = Color.Transparent,
                    unfocusedIndicatorColor = Color.Transparent,
                    focusedContainerColor = Color.Transparent,
                    disabledContainerColor = Color.Transparent,
                    unfocusedContainerColor = Color.Transparent
                ),
            )
            if (actions.isNotEmpty()) {
                actions.forEach {
                    VerticalDivider(Modifier.height(32.dp).align(Alignment.CenterVertically))
                    it()
                }
            }
        }
    }
}